import { Link } from 'react-router-dom';
import { GENRE_LABELS, type StoryListItem } from '@storychain/shared';

interface StoryCardProps {
  story: StoryListItem;
}

const GENRE_EMOJI: Record<string, string> = {
  comedy: '😄',
  horror: '👻',
  romance: '💕',
  scifi: '🚀',
  fantasy: '🐉',
  random: '🎲',
};

export const StoryCard: React.FC<StoryCardProps> = ({ story }) => {
  const cover = story.coverImageMedium || story.coverImage || story.coverImageThumb;
  const emoji = GENRE_EMOJI[story.genre] || '📖';

  return (
    <Link
      to={`/story/${story.id}/completed`}
      className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition flex flex-col"
    >
      <div className="aspect-square bg-gray-100 overflow-hidden">
        {cover ? (
          <img
            src={cover}
            alt={story.title || GENRE_LABELS[story.genre]}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-5xl">{emoji}</div>
        )}
      </div>
      <div className="p-3 flex-1 flex flex-col">
        <h3 className="font-semibold text-gray-900 line-clamp-2 mb-1">
          {story.title || `Story ${story.code}`}
        </h3>
        {story.subhead && (
          <p className="text-xs text-gray-500 line-clamp-1 mb-2 italic">{story.subhead}</p>
        )}
        <div className="mt-auto flex items-center gap-2 text-xs text-gray-500">
          <span className="capitalize px-2 py-0.5 bg-gray-100 rounded-full">
            {emoji} {story.genre}
          </span>
          {(story.reactionCount || 0) > 0 && (
            <span className="tabular-nums">🎭 {story.reactionCount}</span>
          )}
        </div>
      </div>
    </Link>
  );
};
